<template>

  <div class="container">

    <div class="row">

      <div class="col-12 offset-0 col-md-6 offset-md-3 text-center">

        <h1 class="mb-4 menu-dark font-weight-light">Loading...</h1>

      </div>

    </div>

  </div>

</template>

<script>

export default {
  name: 'Auth',
  data() {
    return  {}
  },
  methods: {
    loadData () {
      let token = this.$route.query.jwt;
      let payment_to = this.$route.query.payment_to;


      if (token && payment_to) {

        localStorage.setItem('accessToken', token)
        this.$store.dispatch('storeToken', token)
        this.$store.dispatch('storePaymentTo', payment_to)
        this.$router.replace('/')

      } else {
        this.name = 'Sorry something went wrong!';
      }

    }
  },
  beforeMount(){
      this.loadData()
   },
}
</script>
